// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dJw4XKT9BMFa3ndzV0hU {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 1rem;
  font-size: 1.1rem;
  color: var(--dst-muted);
}

.dpcxpY0OvYHjeT9j2cke {
  color: var(--dst-text);
}

.dpcxpY0OvYHjeT9j2cke p,
.dpcxpY0OvYHjeT9j2cke li,
.dpcxpY0OvYHjeT9j2cke dt,
.dpcxpY0OvYHjeT9j2cke dd,
.dpcxpY0OvYHjeT9j2cke td,
.dpcxpY0OvYHjeT9j2cke th,
.dpcxpY0OvYHjeT9j2cke label,
.dpcxpY0OvYHjeT9j2cke span {
  color: inherit;
}

.dpcxpY0OvYHjeT9j2cke a {
  color: var(--dst-primary, #205ec8);
}

.h5iELe_JdoiStjsS1WhB {
  width: 24px;
  height: 24px;
  border: 3px solid var(--dst-info-border);
  border-top-color: var(--dst-primary);
  border-radius: 50%;
  animation: Zxdq1TVKW4mRAwcHmqeZ 0.9s linear infinite;
}

@keyframes Zxdq1TVKW4mRAwcHmqeZ {
  to { transform: rotate(360deg); }
}

.iNxI7lRHM0VVWhi7fCC8 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
  background: var(--dst-error-bg);
  border: 1px solid var(--dst-error-border);
  border-radius: 8px;
  color: var(--dst-error-text);
  font-size: 1.1rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/App.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,oCAAoC;EACpC,kBAAkB;EAClB,oDAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".lep-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  gap: 1rem;\n  font-size: 1.1rem;\n  color: var(--dst-muted);\n}\n\n.lep-app-root {\n  color: var(--dst-text);\n}\n\n.lep-app-root p,\n.lep-app-root li,\n.lep-app-root dt,\n.lep-app-root dd,\n.lep-app-root td,\n.lep-app-root th,\n.lep-app-root label,\n.lep-app-root span {\n  color: inherit;\n}\n\n.lep-app-root a {\n  color: var(--dst-primary, #205ec8);\n}\n\n.lep-spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid var(--dst-info-border);\n  border-top-color: var(--dst-primary);\n  border-radius: 50%;\n  animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.lep-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 2rem;\n  background: var(--dst-error-bg);\n  border: 1px solid var(--dst-error-border);\n  border-radius: 8px;\n  color: var(--dst-error-text);\n  font-size: 1.1rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lep-loading": `dJw4XKT9BMFa3ndzV0hU`,
	"lep-app-root": `dpcxpY0OvYHjeT9j2cke`,
	"lep-spinner": `h5iELe_JdoiStjsS1WhB`,
	"spin": `Zxdq1TVKW4mRAwcHmqeZ`,
	"lep-error": `iNxI7lRHM0VVWhi7fCC8`
};
export default ___CSS_LOADER_EXPORT___;
